import { API } from "./api";
import { getSessionId } from "./session";
import { getAttribution, liveQaUtms } from "./attribution";

// Build a Hotelstrips-owned SubID for outbound commerce tracking.
// e.g. metlife_stadium_hoboken_hotels_primary (Travelpayouts SubIDs allow [A-Za-z0-9_])
export function buildSubId({ venue, stayArea, event, city, productType, position }) {
  const parts = [venue || event || city || "site", stayArea, productType, position || "primary"].filter(Boolean);
  return parts.join("_").replace(/[^a-z0-9_]/gi, "_").replace(/_+/g, "_").replace(/^_|_$/g, "").toLowerCase();
}

// Outbound href hits our backend /go endpoint which logs the click, then 302s
// to the affiliate deep link (or an internal demo page when no marker configured).
export function ctaHref(ctx) {
  const subid = buildSubId(ctx);
  const values = {
    product_type: ctx.productType,
    provider: ctx.provider || (ctx.productType === "flights" ? "nuitee" : "travelpayouts"),
    subid,
    page: ctx.page || "",
    venue_slug: ctx.venue || "",
    event_slug: ctx.event || "",
    city_slug: ctx.city || "",
    stay_area_slug: ctx.stayArea || "",
    event_date: ctx.eventDate || "",
    check_in: ctx.checkIn || "",
    check_out: ctx.checkOut || "",
    cta_position: ctx.position || "primary",
    session_id: getSessionId(),
  };
  // Carry persisted first-touch inbound attribution onto the outbound click so it can be
  // reconciled by campaign/source even when the original query string is long gone.
  const attr = getAttribution();
  ["utm_source", "utm_medium", "utm_campaign", "utm_content"].forEach((k) => {
    if (attr[k]) values[k] = attr[k];
  });
  if (attr.landing_referrer) values.landing_referrer = attr.landing_referrer;
  // Explicit QA session (QA params on the CURRENT URL): keep QA labels on the click so QA traffic
  // stays excluded from real analytics. Request-scoped only — never persisted, so normal visitors
  // (who never carry QA params) are unaffected.
  const qa = liveQaUtms();
  ["utm_source", "utm_medium", "utm_campaign"].forEach((k) => { if (qa[k]) values[k] = qa[k]; });
  const q = new URLSearchParams();
  Object.entries(values).forEach(([key, value]) => {
    if (value) q.set(key, value);
  });
  return `${API}/go?${q.toString()}`;
}
